import React, { useState } from 'react' 
import {useNavigate} from "react-router-dom";
import { TextField, Box, MenuItem, Button, Typography, Alert, Stack, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import ArrowForwardSharpIcon from '@mui/icons-material/ArrowForwardSharp';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import addDecimal from '../Components/addDecimal';
import GradientCircularProgress from '../Components/GradientCircularProgress';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './Upload.css';


const Upload = (props) => {
  const navigate = useNavigate();
  const updateRelink = () => {
    navigate('/update')
  }
  

  let compTemp = props.comps['driverApps']
  let compTemp2 = compTemp.concat(props.comps['backSeatApps'])
  let compsTemp = compTemp2.concat(props.comps['bookingApps'])
  let compsNew = [];
  let ids = {}

  
  
  compsTemp.forEach(obj=> {
      if (!ids[obj.name]){
          ids[obj.name] = true;
          compsNew.push(obj);
      }
  });  

    const [existingAffiliate, setExistingAffiliate] = useState('')
    const [disabler, setDisabler] = useState(false);
    const [disabler2, setDisabler2] = useState(false);
    const [iAffiliateID, setIAffiliateID] = useState('');
    const [affiliateName, setAffiliateName] = useState('');
    const appTypes = ['Driver', 'BackSeat', 'Booking'];
    const [appType, setAppType] = useState('')
    const [versionNo, setVersionNo] = useState(0);
    const [versionInfo, setVersionInfo] = useState('');
    const [apk, setApk] = useState(null);
    const [bgPhoto, setBgPhoto] = useState(null);
    const [appLogo, setAppLogo] = useState(null);
    const [aboutApp, setAboutApp] = useState('');
    const [screenshots, setScreenshots] = useState([]);
    const [isTesting, setIsTesting] = useState(false);
    const [appleLink, setAppleLink] = useState('');
    const [googleLink, setGoogleLink] = useState('');
    const [uploadComplete, setUploadComplete] = useState(false);
    const [uploadError, setUploadError] = useState(false);
    const [uploadErrorMessage, setUploadErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false)



    async function handleUpload(e){
      e.preventDefault();
      const APILinksFetch = await fetch('/APILinks.json')
      const APILinks = await APILinksFetch.json()
      const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
      const today = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

      
      let navLink = "/".concat(affiliateName)
      navLink = navLink.concat(appType)

      let bgPath = '' 
      

      let appLogoPath = ''

      let downloadLinkPath = '/pages/appPages/'.concat(appType)
      downloadLinkPath = downloadLinkPath.concat(`/${affiliateName}/${affiliateName}-${appType}-${addDecimal(parseFloat(versionNo))}.apk`)

      
      if(!isTesting){

        let data = new FormData();
        if(bgPhoto != null){
        data.append('BGPhoto', bgPhoto)
        bgPath = (`/pages/appPages/${appType}/${affiliateName}/BGPhoto.png`)
        }
        if(appLogo != null){
        data.append('appLogo', appLogo)
        appLogoPath = (`/pages/appPages/${appType}/${affiliateName}/logo.png`)
        }
        
        data.append('apk', apk)

        if(screenshots.length !== 0) {
          for(const file of screenshots){
            data.append('screenshots', file)
          }
        }
        
        
        setIsLoading(true)
        const response = await fetch(APILinks['uploadFile'] + new URLSearchParams({
          iAffiliateID: Number(iAffiliateID),
          affiliateName: affiliateName,
          appType: appType,
          versionNo: addDecimal(versionNo),
          versionInfo: versionInfo,
          releaseDate: today,
          navLink: navLink,
          downloadLink: downloadLinkPath,
          BGPhoto: bgPath,
          appLogo: appLogoPath,
          isTesting: isTesting, 
          aboutApp: aboutApp, 
          appleLink: appleLink,
          googleLink: googleLink,
        }).toString(),
        {
          method: 'PUT',
          body: data
        })
        const uploadData = await response.json()
        if (uploadData['message'] === 'Completed'){
          setUploadComplete(true)
        }
        else{
          setUploadErrorMessage(uploadData['message'])
          setUploadError(true)
        }

      }

      if(isTesting){
        let data = new FormData();
        data.append('apk', apk)
        setIsLoading(true)
        const response = await fetch(APILinks['uploadFile'] + new URLSearchParams({
          iAffiliateID: Number(iAffiliateID),
          affiliateName: affiliateName,
          appType: appType,
          versionNo: addDecimal(versionNo),
          versionInfo: "x",
          releaseDate: today,
          navLink: "x",
          downloadLink: downloadLinkPath,
          BGPhoto: "x",
          appLogo: "x",
          isTesting: isTesting, 
          aboutApp: "x", 
          appleLink: "x",
          googleLink: "x",
        }).toString(),
        {
          method: 'PUT',
          body: data
        })
        
        const uploadData = await response.json()
        if (uploadData['message'] === 'Completed'){
          setUploadComplete(true)
        }
        else{
          setUploadErrorMessage(uploadData['message'])
          setUploadError(true)
        }
      }
    }

    function handleUploadClose(){
      setUploadComplete(false)
      setIsLoading(false)
    }

    function handleErrorClose(){
      setUploadError(false);
      setIsLoading(false);
    }

    function handleExistingAffiliate(e, selectedOption, count){
      let typeList = []
        compsTemp.forEach((app) => {
            if(app.name === e){
                typeList.push(app)
            }
        })
      console.log(e)
      setExistingAffiliate(e)
      setAffiliateName(e);
      setIAffiliateID(typeList[0].iAffiliateID);
      setDisabler(true);
      setDisabler2(true);
      if (count >= 1){
        setAppType(selectedOption.appType);
      }
      else{
        setAppType('');
      }
    }

    return (
    
        <div className='mainPage'>
            { !uploadComplete && <Box
                component="form"
                autoComplete='off'
                className='formContainer'
                onSubmit={handleUpload}
            >

                <Typography variant="h4">
                  Upload a new APK to the ITCurves Store
                </Typography>
                <Button 
                color="secondary" sx={updateTextStyle} 
                endIcon={<ArrowForwardSharpIcon/>}
                onClick={updateRelink}>
                  Want to update an existing APK listing?
                </Button>
                <br/>
                
                <CssTextField name={'affiliate'} 
                    helperText="Autofill existing affiliate"
                    InputLabelProps={{
                        component: 'span',
                    }} 
                    select
                    value={existingAffiliate}
                    onChange={(event) => {
                      const selectedOption = compsNew.find(option => option.name === event.target.value);
                      const count = compsNew.filter(item => ((item.iAffiliateID === selectedOption.iAffiliateID) && (item.name !== selectedOption.name))).length;
                      handleExistingAffiliate(event.target.value, selectedOption, count);
                    }} 
                    label='Affiliate' 
                    variant='outlined' 
                    size='normal' 
                    margin='normal'>
                    {compsNew.map((option) => {
                      let count = compsNew.filter(item => ((item.iAffiliateID === option.iAffiliateID) && (item.name !== option.name))).length;
                      if (count >= 1){
                        return (
                          <MenuItem key={option.name} value={option.name}>
                            {`${option.name} (affID: ${option.iAffiliateID} ${option.appType})`}
                          </MenuItem>
                        );
                      }
                      else{
                        return (
                          <MenuItem key={option.name} value={option.name}>
                            {`${option.name}`}
                          </MenuItem>
                        );
                      }
                      
                    })}
                </CssTextField>
                <br />
                <CssTextField slotProps={{
                                input: {
                                  endAdornment: 
                                    disabler ? (<IconButton
                                                  aria-label="close"
                                                  color="inherit"
                                                  size="small"
                                                  sx={{marginTop: '3%'}}
                                                  onClick={() => {
                                                      setDisabler(false)
                                                  }}
                                                >
                                                  <EditOutlinedIcon fontSize="inherit" />
                                                </IconButton>
                                              ) 
                                              : <></>}}} 
                                inputProps= {{readOnly: disabler}} value={iAffiliateID} sx={{marginTop: '3%'}} required onChange={(event) => setIAffiliateID(event.target.value)} label='Affiliate ID' variant='outlined' size='normal' margin='normal' />
                <CssTextField slotProps={{
                                input: {
                                  endAdornment: 
                                    disabler2 ? (<IconButton
                                                  aria-label="close"
                                                  color="inherit"
                                                  size="small"
                                                  sx={{marginTop: '3%'}}
                                                  onClick={() => {
                                                      setDisabler2(false)
                                                  }}
                                                >
                                                  <EditOutlinedIcon fontSize="inherit" />
                                                </IconButton>
                                              ) 
                                              : <></>}}} 
                                inputProps= {{readOnly: disabler2}} value={affiliateName} name={'affiliateName'} sx={{marginTop: '3%'}} required onChange={(event) => setAffiliateName(event.target.value)} label='Affiliate Name' variant='outlined' size='normal' margin='normal' />

                <br/>
                <CssTextField name={'appType'} 
                InputLabelProps={{
                  component: 'span',
                }} 
                select value={appType} required onChange={(event) => setAppType(event.target.value)} label='App Type' variant='outlined' size='normal' margin='normal'>
                    {appTypes.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </CssTextField>
                
                <CssTextField name={'testing'} sx={{marginLeft: '1%'}} 
                InputLabelProps={{
                  component: 'span',
                }} 
                select value={isTesting} onChange={(event) => setIsTesting(event.target.value)} label='Is Beta?' variant='outlined' size='normal' margin='normal'>  
                  <MenuItem key={'false'} value={false}>
                      False
                  </MenuItem> 
                  <MenuItem key={'true'} value={true}>
                      True
                  </MenuItem>
                </CssTextField>

                <br />
                <CssTextField sx={{marginTop: '1%'}} required onChange={(event) => setVersionNo(event.target.value)} label='Version #' variant='outlined' size='normal' margin='normal' />

                <CssTextField name={"versionInfo"} sx={{marginTop: '2%'}} required fullWidth multiline onChange={(event) => setVersionInfo(event.target.value)} label='Version Changes' variant='outlined' size='normal' margin='normal' />
                
                <CssTextField name={'apk'} sx={{marginTop: '3%'}} required InputLabelProps={{shrink: true}} onChange={(event) => {setApk(event.target.files[0])}} type='file' label='Upload APK' />

                { !isTesting && <CssTextField name={'bgPhoto'} sx={{marginTop: '3%'}} InputLabelProps={{shrink: true}} onChange={(event) => {setBgPhoto(event.target.files[0])}} type='file' label='Background Photo' /> }

                { !isTesting && <CssTextField name={'appLogo'} sx={{marginTop: '3%'}} InputLabelProps={{shrink: true}} onChange={(event) => {setAppLogo(event.target.files[0])}} type='file' label='App Logo' /> }

                { !isTesting && <CssTextField name={'screenshots'} sx={{marginTop: '3%'}} InputLabelProps={{shrink: true}} inputProps={{multiple: true}} onChange={(event) => {setScreenshots(Array.from(event.target.files))}} type='file' label='Screenshots' /> }

                { !isTesting && <CssTextField name={'aboutApp'} sx={{marginTop: '3%'}} fullWidth multiline onChange={(event) => setAboutApp(event.target.value)} label='About this app' variant='outlined' size='normal' margin='normal' /> }
                
                { !isTesting && <CssTextField name={'appleLink'} sx={{marginTop: '3%'}} onChange={(event) => setAppleLink(event.target.value)} label='Apple Store Link' variant='outlined' size='normal' margin='normal' /> }
                { !isTesting && <CssTextField name={'googleLink'} sx={{marginTop: '3%', marginLeft: '1%'}} onChange={(event) => setGoogleLink(event.target.value)} label='Play Store Link' variant='outlined' size='normal' margin='normal' /> }

                <br />
                { !uploadError ? 

                (!isLoading ? 

                (iAffiliateID !== '' && 
                affiliateName !== ''
                && appType !== '' 
                && versionNo !== 0 
                && versionInfo !== '' 
                && apk !== null) ? 

                  <Button type="submit" sx={buttonStyle} variant="outlined" className='upload' startIcon={<CloudUploadOutlinedIcon />}>
                    Upload
                  </Button> 
                : 
                  <Button disabled type="button" sx={disabledButtonStyle} variant="outlined" className='upload' startIcon={<CloudUploadOutlinedIcon />}>
                    Upload
                  </Button> 
                : 
                
                  <Stack className="stack" alignItems="center" sx={{width: '100%', height: '100%'}}> 
                    <GradientCircularProgress />
                  </Stack>) 
                            
                : 
                            
                  <Alert sx={{width: '50%', margin: 'auto'}} variant="outlined" severity='error'
                  action={
                    <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                        handleErrorClose();
                    }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }> 
                    {uploadErrorMessage}
                  </Alert> 
                }
            </Box>}

            {uploadComplete && 
                <Alert sx={{width: '50%', margin: 'auto'}} variant="outlined" severity='success'
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        handleUploadClose();
                      }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                    }
                  > 
                    Upload has been completed
                  </Alert> 
              }
            
        </div>)
};

export default Upload;

const CssTextField = styled(TextField)({
  minWidth: '125px;',
 '& .MuiInput': {overflow: 'wrap'},
  '& label.Mui-focused': {
  color: '#141419',
},
'& .MuiInput-underline:after': {
  borderBottomColor: '#141419',
},
'& .MuiOutlinedInput-root': {
  '& fieldset': {
    borderColor: '#717171',
  },
  '&:hover fieldset': {
    borderColor: '#141419',
  },
  '&.Mui-focused fieldset': {
    borderColor: '#0A21C0',
  },
},
})

const buttonStyle = {
margin: 'auto',
marginTop: '15px',
marginBottom: '15px',
width: 'auto',
height: 'auto',
color: 'whitesmoke',
fontSize: '15px',
boxShadow: "5",
backgroundColor: '#141619',
borderColor: '#141419',
"&:hover": {
  backgroundColor: 'green',
  borderColor: 'green',
  WebkitTextFillColor: 'white',
  boxShadow: "15",
},
"&::after":{
  WebkitTextFillColor: 'white'
}
}

const updateTextStyle = {
margin: 'auto',
width: 'auto',
height: 'auto',
fontSize: '10px !important',
"&:hover": {
  color: 'black !important',
  backgroundColor: 'transparent'
}
}

const disabledButtonStyle = {
margin: 'auto',
marginTop: '15px',
marginBottom: '15px',
width: 'auto',
height: 'auto',
color: 'whitesmoke',
fontSize: '15px',
boxShadow: "5",
backgroundColor: 'whitesmoke',
borderColor: '#141419',
"&:hover": {
  backgroundColor: '#050A44',
  borderColor: '#141419',
  WebkitTextFillColor: 'white',
  boxShadow: "15",
},
"&::after":{
  WebkitTextFillColor: 'white'
}
}

Upload.propTypes ={
  comps: PropTypes.any
}